const QR_FORMAT_KEY = "qr_format";

// "folio": el QR lleva solo el folio. "json": {"folio":"CF0003","nombre":"JUAN PEREZ"}
export type QrFormat = "folio" | "json";

export const DEFAULT_QR_FORMAT: QrFormat = "folio";

export function getSavedQrFormat(): QrFormat {
    if (typeof window === "undefined") return DEFAULT_QR_FORMAT;
    try {
        return localStorage.getItem(QR_FORMAT_KEY) === "json" ? "json" : DEFAULT_QR_FORMAT;
    } catch {
        return DEFAULT_QR_FORMAT;
    }
}

export function saveQrFormat(format: QrFormat) {
    if (typeof window === "undefined") return;
    try {
        localStorage.setItem(QR_FORMAT_KEY, format);
    } catch {
        // Sin almacenamiento disponible: se usa el valor por defecto
    }
}
